import { render, staticRenderFns } from "./FoldModule.vue?vue&type=template&id=507b4bfa&"
import script from "./FoldModule.vue?vue&type=script&lang=js&"
export * from "./FoldModule.vue?vue&type=script&lang=js&"
import style0 from "./FoldModule.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('507b4bfa')) {
      api.createRecord('507b4bfa', component.options)
    } else {
      api.reload('507b4bfa', component.options)
    }
    module.hot.accept("./FoldModule.vue?vue&type=template&id=507b4bfa&", function () {
      api.rerender('507b4bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/FoldModule.vue"
export default component.exports